import { useLocation } from "react-router-dom";

const years = [2026,2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010];
const allSubjects=[
        "हिंदी",
        "अंग्रेज़ी",
        "संस्कृत",
        "शारीरिक शिक्षा",
        "समाज शास्त्र",
        "राजनीतिक शास्त्र",
        "इतिहास",
        "भूगोल","Physics","Chemistry","Maths","Botany","Zoology",
        "Business Communication","Business Statistics","Business Organisation","Introduction to Computer Application,Food",
        " Nutrition, & Hygiene  Co-curricular","Business Management","Financial Accounting","Computerised Accounting","Essentials of E-Commerce","Business Economics","First Aid and Health Co-curricular","Inventory Management","Cost According "
      ];
const subjects=window.location.toString().split("/")[4]==="bsc"

?


["Physics","Chemistry","Maths","Botany","Zoology"]


:window.location.toString().split("/")[4]==="ba"

?

[
        "हिंदी",
        "अंग्रेज़ी",
        "संस्कृत",
        "शारीरिक शिक्षा",
        "समाज शास्त्र",
        "राजनीतिक शास्त्र",
        "इतिहास",
        "भूगोल"
      ]
      
:

["Business Communication","Business Statistics","Business Organisation","Introduction to Computer Application,Food"," Nutrition, & Hygiene  Co-curricular","Business Management","Financial Accounting","Computerised Accounting","Essentials of E-Commerce","Business Economics","First Aid and Health Co-curricular","Company Law","Business Regulatory Framework"]; 



const subjects2=[]; 
const form = {
  "Basic Info": [
    { name: "urn", type: "text", label: "URN",required:false },
    { name: "applicant_name", type: "text", label: "Applicant Name",required:false },
    { name: "mother_name", type: "text", label: "Mother's Name" ,required:false},
    { name: "father_name", type: "text", label: "Father's Name",required:false },
    { name: "dob", type: "date", label: "Date of Birth",required:false },
    {
      name: "gender",
      type: "select",
      label: "Gender",
      values: ["male", "female", "other"],
      required:false,
    },
    {
      name: "category",
      type: "select",
      label: "Category",
      values: ["general", "obc", "sc", "st"],
      required:false
    },
    { name: "sub_category", type: "text", label: "Sub-Category/Caste",required:false },
    {
      name: "religion",
      type: "select",
      label: "Religion",
      values: ["Hindu", "Muslim", "Sikh", "Christian", "Jainism", "Buddhism", "other"],
      required:false
    },
    { name: "email", type: "email", label: "Email",required:false },
    { name: "whatsapp_number", type: "tel", label: "Whatsapp Number",required:false },
    { name: "applicant_mobile", type: "tel", label: "Applicant Mobile",required:false },
    { name: "aadhar_no", type: "text", label: "Aadhar Number",required:false },
    { name: "c_address", type: "textarea", label: "Correspondence Address",required:false },
    { name: "p_address", type: "textarea", label: "Permanent Address",required:false },
    { name: "same_as_correspondence", type: "radio", label: "Same as Correspondence Address?", values: ["yes", "no"],required:false },
    { name: "local_guardian_name", type: "text", label: "Local Guardian's Name",required:false },
    { name: "local_guardian_contact", type: "tel", label: "Local Guardian Contact",required:false },
    { name: "local_guardian_address", type: "textarea", label: "Local Guardian Address",required:false }
  ],

  "eligibility": [
    {
      name: "horizontal_reservation",
      type: "checkbox",
      label: "Horizontal Reservation",
      values: [
        "Physically Handicap(दिव्यांग)",
        "Dependent of Freedom Fighter(स्वतंत्रता सेनानी पाल्य)",
        "Defence Personel(प्रतिरक्षा कर्मचारी)"
      ],
      required:false,
    },
    {
      name: "weightage",
      type: "checkbox",
      label: "Weightage",
      values: [
        "N.C.C (B Certificate)",
        "N.C.C (C Certificate)",
        "N.S.S (240 Hours Certificate)",
        "College Employee Dependent (पाल्य)",
        "Rajyapal Award (राज्यपाल पुरस्कार)",
        "Scout and Guide (तृतीय सोपान)",
        "Ranger, Nipun Exam Passed",
        "Ranger, Member of National Team"
      ],
      required:false
    },
    {
      name: "nationality",
      type: "select",
      label: "Nationality",
      values: ["Indian", "Other"],
      required:false
    },
    {
      name: "is_minority",
      type: "select",
      label: "Are you from a minority community?",
      values: ["yes", "no"],
      required:false
    },
    {
      name: "is_otherenrollment",
      type: "select",
      label: "Enrolled elsewhere this session?",
      values: ["yes", "no"],
      required:false
    },
    {
      name: "is_upresidence",
      type: "select",
      label: "Are you a resident of Uttar Pradesh?",
      values: ["yes", "no"],
      required:false
    }
  ],

  "income_details": [
    { name: "annual_income", type: "number", label: "Annual Income",required:false },
    { name: "income_certificate_no", type: "text", label: "Income Certificate No.",required:false },
    { name: "bank_name", type: "text", label: "Bank Name",required:false },
    { name: "bank_branch", type: "text", label: "Branch",required:false },
    { name: "bank_account", type: "text", label: "Account Number",required:false },
    { name: "bank_isfsc", type: "text", label: "IFSC Code",required:false }
  ],

  "education_details": [
    {breakTitle: "Enter High School Details", type:"break",required:false },
    { name: "high_school_year", type: "select", values: years, label: "High School Year",required:false },
    { name: "high_school_board", type: "text", label: "High School Board",required:false },
    { name: "high_school_name", type: "text", label: "High School Name",required:false },
    { name: "high_school_roll", type: "text", label: "High School Roll No.",required:false },
    { name: "high_school_maxmarks", type: "number", label: "High School Max Marks",required:false },
    { name: "high_school_obtmarks", type: "number", label: "High School Marks Obtained",required:false },
    { name: "high_school_percentage", type: "number", label: "High School Percentage",required:false },
    { name: "high_school_subject", type: "text", label: "High School Subjects" ,required:false },
{breakTitle: "Enter Intermediate Details", type:"break",required:false },
    { name: "intermediate_year", type: "select", values: years, label: "Intermediate Year",required:false },
    { name: "intermediate_board", type: "text", label: "Intermediate Board",required:false },
    { name: "intermediate_name", type: "text", label: "Intermediate School Name",required:false },
    { name: "intermediate_roll", type: "text", label: "Intermediate Roll No.",required:false },
    { name: "intermediate_maxmarks", type: "number", label: "Intermediate Max Marks",required:false },
    { name: "intermediate_obtmarks", type: "number", label: "Intermediate Marks Obtained",required:false },
    { name: "intermediate_percentage", type: "number", label: "Intermediate Percentage",required:false },
    { name: "intermediate_subject", type: "text", label: "Intermediate Subjects",required:false },


    {breakTitle: "First Year Details", type:"break",required:false,onlyFor:"Part-2",name:"first_year_details"},



    { name: "ug_1styear", type: "select", values: years, label: "Passing Year",required:false,onlyFor:"Part-2" },

    { name: "ug_board", type: "text", label: "Board",required:false,onlyFor:"Part-2" },

    { name: "ug_name", type: "text", label: "Collage Name",required:false,onlyFor:"Part-2" },

    { name: "ug_1styear_rollno", type: "text", label: "First Year Roll No.",required:false ,onlyFor:"Part-2"},

    { name: "ug_1styear_maxmarks", type: "number", label: "First Year Max Marks",required:false ,onlyFor:"Part-2"},

    { name: "ug_1styear_obtmarks", type: "number", label: "First Year Marks Obtained",required:false ,onlyFor:"Part-2"},
    
    { name: "ug_1styear_percentage", type: "number", label: "First Year Percentage",required:false ,onlyFor:"Part-2"},

     { name: "first_sem_sub", type: "text", label: "First Semester Subjects (separated by commas)",required:false ,onlyFor:"Part-2"},

      { name: "second_sem_sub", type: "text", label: "Second Semester Subjects (separated by commas)",required:false ,onlyFor:"Part-2"},
  
    {"breakTitle":"Please Select Subjects to Pursue", name:"break",type:"break",required:false},
    {
      name: "first_major_subject",
      type: "select",
      label: "Major Subject 1",
      values: subjects,required:false
    },
    {
      name: "second_major_subject",
      type: "select",
      label: "Major Subject 2",
      values: subjects , required:false
    },
    {
      name: "minor_subject",
      type: "select",
      label: "Minor Subject",
      values: allSubjects , required:false
    },
    // {
    //   name: "compulsory_subjects",
    //   type: "checkbox",
    //   label: "Compulsory Subjects",
    //   values: subjects
    // }
  ],

  "upload_section": [
    {
      name: "image",
      type: "file",
      accept: "image/*",
      maxSizeKB: 500,
      label: "Upload Image (500kb max)"
    },
    {
      name: "signature",
      type: "file",
      accept: "image/*",
      maxSizeKB: 200,
      label: "Upload Signature (200kb max)"
    },
    {
      name: "is_otherenrollment",
      type: "select",
      values: ["yes", "no"],
      required:false,
      label: "क्या आपने वर्तमान सत्र में किसी अन्य शिक्षण सस्थान में प्रवेश लिया है यदि हाँ तो उल्लेख करें ।"
    },
    {
      name: "has_scholarship",
      type: "select",
      required:false,
      values: ["yes", "no"],
      label: "क्या आपको गत्त वर्ष छात्रवृत्ति प्राप्त हुई थी"
    },
    {
      name: "is_casefiled",
      type: "select",
      required:false,
      values: ["yes", "no"],
      label: "क्या आपके विरुद्ध कोई अभियोग चल रहा है , चल चुका है किसी अभियोग में दण्डित हो चुके हैं यदि हाँ तो पूर्ण विवरण दें -"
    },
    {
      name: "is_rustigated",
      type: "select",
      required :false,
      values: ["yes", "no"],
      label: "क्या विगत सत्र आपको महाविद्यालय प्रशासन ने अनुशासन भंग करने के कारण चेतावनी दी / निलंबित किया / निष्काषित किया ? यदि हाँ तो पूर्ण विवरण दें गलत जानकारी के लिए प्रवेश पर विचार नहीं किया जाएगा/प्रवेश निरस्त कर दिया जायेगा ।"
    },
    {
      name: "is_civilservant",
      type: "select",
      required:false,
      values: ["yes", "no"],
      label: "क्या आप सेवारत हैं यदि हाँ, तो अपने पद, कार्यालय और नियोजन का उल्लेख करें।"
    },
    {
      name: "is_ufmeans",
      type: "select",
      values: ["yes", "no"],
      label: "क्या आप गत परीक्षाओं में अनुचित साधन का प्रयोग करते पकड़े गए हैं यदि हाँ तो पूर्ण विवरण दें ।"
    },
    {
      
     "name":"break",
     "type":"break"
    },
    {
      name: "agreed_to_declaration",
      type: "checkbox",
      label: "I hereby agree to the terms and conditions and declare that all the information provided is correct."
    },
     
  ]
};

export default form;
